export default [

  {
    url: "/vp/dashboard",
    name: "Dashboard",
    slug: "admin-home",
    permission: "vp.vp.dashboard.show",
    icon: "PieChartIcon",
  },
  {
    url: "/vp/lists",
    name: "Lists",
    slug: "lists",
    permission: "vp.vp.lists.show",
    icon: "ListIcon",
    /*submenu: [
      {
        url: 'http://google.dk',
        name: "CRM Events",
        slug: "crm-events",
        i18n: "Analytics",
      },

    ]*/
  },
  {
    url: "/vp/tasks",
    name: "Venue tasks",
    slug: "venue-tasks",
    permission: "vp.vp.venuetasks.show",
    icon: "ZapIcon",
  },
  {
    url: "/vp/todos",
    name: "Your todos",
    slug: "personal-todos",
    icon: "InboxIcon",
    permission: "vp.vp.personaltodos.show",
  },
  {
    url: "/vp/info",
    name: "Venue info",
    slug: "venue-info",
    icon: "InfoIcon",
    permission: "vp.vp.venueinfo.show",
  },
  {
    url: "/vp/activationplan",
    name: "Activation plan",
    slug: "activation-plan",
    permission: "vp.vp.activationplan.show",
    icon: "LayoutIcon",
  },
  {
    url: "/vp/venuedrive",
    name: "Venue Drive",
    slug: "venue-drive",
    permission: "vp.vp.venuedrive.show",
    icon: "HardDriveIcon",
  },
  {
    url: "/vp/venuecampaigns",
    name: "Venue campaigns",
    slug: "vp-venuecampaigns",
    permission: "vp.vp.venuecampaigns.view",
    icon: "LayersIcon",
  },
  {
    url: "/vp/crm-events",
    name: "CRM events",
    slug: "crm-events",
    permission: "vp.devfeature",
    icon: "LinkIcon",
    disabled: true,
  },
  {
    header: 'Booking',
    items: [
      {
        url: "/marcom/marcom",
        name: "Table booking",
        slug: "marcom",
        permission: "vp.vp.booking.show",
        icon: "CalendarIcon",
      },
    ]
  },
];
